import { Box, Button, Collapse, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { LightBanner } from "./LightBanner";

export interface CollectionProps {}

export function Collection({}: CollectionProps) {
  const [show, setShow] = useState(true);

  return (
    <Box>
      <Typography variant="h5" lineHeight={1} sx={{ mb: 1 }}>
        Collection, Use and Disclosure of Personal Information
      </Typography>
      <LightBanner
        direction="row"
        spacing={2}
        justifyContent="space-between"
        alignItems="center"
        py={2}
        sx={
          show
            ? {
                borderBottom: "none",
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }
            : {}
        }
      >
        <Box>
          <Typography>
            How IRC collects, uses and shares your personal information to
            review and process this request, and how to withdraw your consent.
          </Typography>
        </Box>
        <Button
          onClick={() => setShow(!show)}
          variant="text"
          sx={(theme) => ({
            textTransform: "none",
          })}
        >
          <Typography
            variant="body1"
            lineHeight={1}
            sx={(theme) => ({
              borderBottom: `2px solid ${theme.palette.primary.main}`,
            })}
          >
            Show {show ? "Less" : "More"}
          </Typography>
        </Button>
      </LightBanner>
      <Collapse in={show}>
        <Box p={2} bgcolor="#f5f5f5" borderLeft={4} borderColor="primary.main">
          <Typography pb={2}>
            Inuvialuit Regional Corporation (“IRC”) collects, uses, and
            discloses your personal information in accordance with applicable
            federal and territorial privacy laws. This information is used to
            help review, process, and administer your request under the Inuit
            Child First Initiative, including in accordance with applicable
            Inuit CFI guidelines. You have the right to protect, access, and
            request correction of your personal information. If you have
            questions about how we collect, use and disclose your information,
            contact{" "}
            <a href="mailto:inuitcfi@inuvialuit.com">inuitcfi@inuvialuit.com</a>
            .
          </Typography>
          <Typography pb={2}>
            Personal information may be used to determine eligibility, review
            and process a request, arrange payment or reimbursement, and
            coordinate services. Where needed for these purposes, IRC may share
            relevant information with Inuit CFI, Indigenous Services Canada,
            professionals responsible for the child’s health, education, or
            social development, educational programs, provinces and territories,
            municipal governments, Indigenous organizations, and private-sector
            service providers or vendors. This helps reduce duplication of
            applications and helps ensure the child receives needed services on
            time. When IRC shares personal information with professionals, IRC
            advises them that they may only use the information for the purpose
            of processing this request.
          </Typography>
          <Typography pb={2}>
            By submitting this funding request, you confirm that you understand
            why your personal information is collected, how it may be used, and
            where it may be shared to review, process, administer, or refer your
            request. If required information is missing, or if you choose not to
            provide it, your funding request may be delayed or may not be able
            to proceed. You may withdraw your consent by contacting IRC at{" "}
            <a href="mailto:inuitcfi@inuvialuit.com">inuitcfi@inuvialuit.com</a>
            .
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
}
